export const drawGraphBackground = (context, canvasOffset, zoom) => {
  const gridSize = 50; // Spacing between grid lines
  const width = context.canvas.width / zoom;
  const height = context.canvas.height / zoom;
  context.save();
  context.scale(zoom, zoom); // Scale the drawing context
  context.clearRect(0, 0, width, height); // Clear the canvas before drawing

  // Adjust starting points based on the offset to simulate infinite scrolling
  const xOffset = canvasOffset.x % gridSize;
  const yOffset = canvasOffset.y % gridSize;

  context.beginPath();
  // Set the color and width of the grid lines
  context.strokeStyle = "#eaeaea"; // Light grey for the grid lines
  context.lineWidth = 1;

  // Draw vertical lines
  // for (let x = xOffset; x < width; x += gridSize) {
  //   context.moveTo(x, 0);
  //   context.lineTo(x, height);
  // }

  // // Draw horizontal lines
  // for (let y = yOffset; y < height; y += gridSize) {
  //   context.moveTo(0, y);
  //   context.lineTo(width, y);
  // }

  context.stroke(); // Apply the lines to the canvas
  context.restore();
};
